import { RequestTypeMapping } from '../LoginUserInfo/RequestTypeMapping';
export class Organization{
    orgName:string;
    orgManager:string;
    superAdmins:string[]=[];
    requestTypes:string[]=[];
    highLevelRequestTypeMapping: RequestTypeMapping[] = [];
    rootCause:string[]=[];
    requestTypeRootCauseMapping: {};
    enableGroupLevelOverride:boolean;
    workflowStatus:string;
    maker:string;
    workflowRemarks:string;
    modBy:string;
    crtBy:string;
    modDate:Date;
    crtDate:Date;
    enableOrgLevelMetaData:boolean;
}